// Message conventions shared with TribeX Meeting, which owns the chat backend and the full chat UI. Kept identical to
// EnterpriseMeeting/web/src/lib/importance.ts and lib/drafts.ts so a message or draft means the same in both apps.

export type Importance = "standard" | "important" | "urgent";

const WRAP = /^\s*<div data-fg-importance="(important|urgent)">([\s\S]*)<\/div>\s*$/;

export function wrapImportance(html: string, importance: Importance): string {
    return importance === "standard" ? html : `<div data-fg-importance="${importance}">${html}</div>`;
}

export function splitImportance(html: string): { importance: Importance; html: string } {
    const m = WRAP.exec(html);
    return m ? { importance: m[1] as Importance, html: m[2]! } : { importance: "standard", html };
}

/** A system line ("Priya added Alex"): the server writes <p data-fg-system><em>…</em></p>. Returns its text or null. */
export function systemNoteText(html: string): string | null {
    if (!html.includes("data-fg-system")) return null;
    const inner = /<em>([\s\S]*?)<\/em>/.exec(html)?.[1] ?? "";
    return inner.replace(/<[^>]*>/g, "").replace(/&amp;/g, "&").replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&quot;/g, "\"").replace(/&#39;/g, "'");
}

const DRAFT = "fg.mail.chatDraft:";
export function readDraft(key: string): string {
    try { return window.localStorage.getItem(DRAFT + key) ?? ""; } catch { return ""; }
}
export function writeDraft(key: string, text: string) {
    try {
        if (text.trim()) window.localStorage.setItem(DRAFT + key, text);
        else window.localStorage.removeItem(DRAFT + key);
    } catch { /* private mode */ }
}
